import {combineLatest} from 'rxjs';
import {map, throttleTime, switchMap} from 'rxjs/operators';
import {currenciesCurrencyCache$, contracts$, riskEngineMode$} from '@/config';
import {contractSubUserIds$, contractBotTradeUserIds$, copyTradeUserIds$} from '@/raw/users';
import {positionsAll$} from '@/positions/all/positions-all';
import {contractAccountsCacheSubs$} from './contract-accounts-cache-all';
import {convertAccount} from '../contract-accounts';

import type {Observable} from 'rxjs';
import type {ws, ContractAccount} from '@/types';

export const contractAccountsSubs$ = combineLatest([
  contractSubUserIds$,
  contractAccountsCacheSubs$,
  positionsAll$,
  currenciesCurrencyCache$,
  contracts$,
  riskEngineMode$,
]).pipe(
  throttleTime(100),
  map(([userIds, accountsCacheAll, positionsAll, currencies, contracts, riskEngineMode]) => {
    return userIds.reduce((acc, userId) => {
      return acc.set(
        userId,
        (accountsCacheAll.get(userId) || new Map())
          .toArray()
          .map((account) =>
            convertAccount(account, positionsAll.get(userId) || [], currencies, contracts, riskEngineMode)
          )
          .filter(Boolean)
      );
    }, new Map<number, ContractAccount[]>());
  })
);

export const copyTradeAccountMap$ = filterAccounts(copyTradeUserIds$);
export const botTradeAccountMap$ = filterAccounts(contractBotTradeUserIds$);

function filterAccounts(ids$: Observable<number[]>) {
  return ids$.pipe(
    switchMap((ids) =>
      contractAccountsSubs$.pipe(
        map((accounts) => {
          return ids.reduce((acc, id) => {
            return acc.set(id, accounts.get(id) || []);
          }, new Map<number, ContractAccount[]>());
        })
      )
    )
  );
}
